import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import Home from "./home";
import SuperAdminRouter from "./superadmin/superAdminRouter";
import AdminRouter from "./admin/adminRouter";
import UserRouter from "./user/userRouter";
import LmsLearnerRouter from "./lms/lmsLearnerRouter";
import LearnerSetPassword from "./lms/learnerSetPassword";
import PrivacyPolicy from "./staticPages/privacePolicy";
import TermsAndCondition from "./staticPages/termsAndCondition";
import { InactivityProvider } from "./contexts/InactivityContext";
import AccessibilityStatement from "./staticPages/accessibilityStatement";
import { legacyLearnerRedirectPath } from "./lms/_learnerConfig";
import { loadLanguage } from "./i18n/i18n";
import { getInterfaceLanguage } from "./i18n/requestLanguage";
import { GlobalNotFound } from "./_shared/routeGuards";

const PortalLanguageSync = () => {
  const location = useLocation();

  useEffect(() => {
    loadLanguage(
      getInterfaceLanguage(location.pathname, location.state, location.search)
    );
  }, [location.pathname, location.search, location.state]);

  return null;
};

// Preserve previously emailed/bookmarked URLs while canonicalizing them to the
// learner route without the retired fixed `/eshs` segment.
const LegacyLmsLearnerRedirect = () => {
  const { orgName, "*": childPath } = useParams();
  const location = useLocation();
  const destination = legacyLearnerRedirectPath(
    orgName,
    childPath,
    location.search,
    location.hash
  );

  return <Navigate to={destination} replace />;
};

// Single-host, path-based routing. There is no per-tenant subdomain: the admin,
// superadmin, user and learner apps are distinguished purely by path, and the
// learner portal carries its tenant in the path (/e-learning/{shortName}/*).
const Router = () => {
  return (
    <InactivityProvider>
      <PortalLanguageSync />
      <Routes>
        <Route path="/superadmin/*" element={<SuperAdminRouter />} />
        <Route path="/admin/*" element={<AdminRouter />} />
        <Route path="/user/*" element={<UserRouter />} />
        {/* Learner portal — path-based tenancy: /e-learning/{lmsShortName}/* */}
        <Route
          path="/e-learning/:orgName/eshs/*"
          element={<LegacyLmsLearnerRedirect />}
        />
        <Route path="/e-learning/:orgName/*" element={<LmsLearnerRouter />} />
        {/* Legacy top-level activation/reset links (short name comes from the query). */}
        <Route path="/setpassword" element={<LearnerSetPassword />} />
        <Route path="/set-password" element={<LearnerSetPassword />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/privacy-notice" element={<PrivacyPolicy />} />
        <Route path="/accessibility-statement" element={<AccessibilityStatement />} />
        <Route path="/terms-and-conditions" element={<TermsAndCondition />} />
        <Route path="/" element={<Navigate to="/user/login" replace />} />
        <Route path="*" element={<GlobalNotFound />} />
      </Routes>
    </InactivityProvider>
  );
};

export default Router;
